import atom from "../images/atom.png";
import fruit from "../images/fruit.png";
import fire from "../images/fire.png";
import veg from "../images/veg.png";
import knife from "../images/knife.png";
const lossVideos = [
  {
    number: 1,
    text: "Introduction and Core Concepts",
    list: [],
    icon: fruit,
  },
  {
    number: 2,
    text: "The Key to Weight Loss According to the Science",
    list: [
      "Principles of calorie consumption",
      "The role of exercise",
      " Basal metabolic rate",
      "How to stay feeling full/satisfied",
      " Psychology of eating (basics)",
    ],
    icon: atom,
  },
  {
    number: 3,
    text: "Hidden calories",
    list: [
      "Learn where the biggest mistakes are made in consumption",
      "How the deck is stacked against you and how to change your odds",
      "Navigating the restaurant minefield",
    ],
    icon: fire,
  },
  {
    number: 4,
    text: "The structure of your diet",
    list: [
      "How to structure your diet for long term success",
      "Key pitfalls that stump even nutritionists",
      "Other factors like glycemic index and food combining",
      "Beverages",
      "What happens when you screw up?",
    ],
    icon: veg,
  },
  {
    number: 5,
    text: "Structure of your daily meals – keeping it simple",
    list: [
      "Portions and specific review of each meal",
      "Examples of exactly what to eat and why",
      "Specifics on each category of food in the program",
      "What to do about rice, pasta, smoothies etc. – common questions",
    ],
    icon: knife,
  },
];

export default lossVideos;
